import React from "react";
import { Outlet } from "react-router-dom";
import { ErrorBoundary } from "react-error-boundary";

import {
  EErrorLevel,
  EErrorSource,
  errorLogger,
} from "@/utils/ubaTracking.utils";
import { captureException } from "@/utils/sentry";
import ErrorBoundaryFallback from "./ErrorBoundary";

const logError = (error: Error, info: React.ErrorInfo) => {
  // UBA: errorLog - exception
  errorLogger(error, EErrorLevel.CRITICAL, EErrorSource.EXCEPTION, {}, info);
  captureException(error);
};

function ErrorBoundaryLayout() {
  return (
    <ErrorBoundary FallbackComponent={ErrorBoundaryFallback} onError={logError}>
      <Outlet />
    </ErrorBoundary>
  );
}

export default ErrorBoundaryLayout;
